module.exports = __webpack_public_path__ + "img/09e11b3.jpg";